// Throws on render so the deployed app can be smoke-tested against
// Sentry by visiting /_sentry-test exactly once. Caught by the
// top-level Sentry.ErrorBoundary -- it does not crash the app.
export default function SentryTest(): JSX.Element {
  throw new Error('Sentry submit smoke test')
}
